<template>
  <div class="footer wrapper box-padding clearfix">
    <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
      <h3 style="font-weight: 600">{{$t('footer[0].links_title')}}</h3>
      <div class="row clearfix">
        <!--<div class="col-sm-4 col-xs-6"><router-link to="index" class="icon icon-home">首页</router-link></div>-->
        <!--<div class="col-sm-4 col-xs-6"><router-link to="works" class="icon icon-case">案例</router-link></div>-->
        <!--<div class="col-sm-4 col-xs-6"><router-link to="about" class="icon icon-about">关于我们</router-link></div>-->
        <!--<div class="col-sm-4 col-xs-6"><router-link to="news" class="icon icon-news">新闻</router-link></div>-->
        <!--<div class="col-sm-4 col-xs-6"><router-link to="service" class="icon icon-client">客户</router-link></div>-->
        <!--<div class="col-sm-4 col-xs-6"><router-link to="contact" class="icon icon-contact">联系我们</router-link></div>-->

        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px">
          <router-link to="index">
            <div class="links-div">
              <img src="../assets/img/icon/icon-home_new.png" alt="">
              <a>{{$t('footer[0].links_content[0]')}}</a>
            </div>
          </router-link>
        </div>
        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px" id="link2">
          <router-link to="works">
            <div class="links-div" style="padding-left: 14px;padding-right: 14px;box-sizing: border-box">
              <img src="../assets/img/icon/icon-case_new.png" alt="" >
              <a>{{$t('footer[0].links_content[1]')}}</a>
            </div>
          </router-link>
        </div>
        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px" id="link3">
          <router-link to="about">
            <div class="links-div">
              <img src="../assets/img/icon/icon-about_new.png" alt="">
              <a>{{$t('footer[0].links_content[2]')}}</a>
            </div>
        </router-link>
        </div>
        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px">
          <router-link to="business">
            <div class="links-div">
              <img src="../assets/img/icon/icon-business.png" alt="">
              <a>{{$t('footer[0].links_content[3]')}}</a>
            </div>
        </router-link>
        </div>
        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px" id="link5">
          <router-link to="service">
            <div class="links-div" style="padding-left: 14px;padding-right: 14px;box-sizing: border-box">
              <img src="../assets/img/icon/icon-client_new.png" alt="">
              <a>{{$t('footer[0].links_content[4]')}}</a>
            </div>
          </router-link></div>
        <div class="col-sm-4 col-xs-4" style="padding-bottom: 15px" id="link6">
          <router-link to="contact">
            <div class="links-div">
              <img src="../assets/img/icon/icon-contact_new.png" alt="">
              <a>{{$t('footer[0].links_content[5]')}}</a>
            </div>
          </router-link></div>

      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-5 col-lg-5">
      <h3 style="font-weight: 600">{{$t('footer[1].contacts_title')}}</h3>
      <div class="row">
        <div class="col-sm-4  col-xs-12 col-md-4 col-lg-4">
          <div class="email">{{$t('footer[1].contacts_content[1].domestic_title')}}<br>
            <div>
              <span style="line-height: 30px;padding-right: 15px" v-html="$t('footer[1].contacts_content[1].domestic_name1')"></span>
              <span>{{$t('footer[1].contacts_content[1].domestic_email1')}}</span>
            </div>
            <div>
            </div>
          </div>
        </div>
        <div class="col-sm-4  col-xs-12 col-md-4 col-lg-4">
          <div class="email">{{$t('footer[1].contacts_content[2].recruitment_title')}}<br/>
            <div>
              <span>{{$t('footer[1].contacts_content[2].recruitment_email')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
      <h3 style="font-weight: 600">{{$t('footer[2].partners_title')}}</h3>
      <!--<div class="partner-container">-->
        <!--<div class="partner partner1">-->
          <!--<a href="https://meizhuang.tmall.com/" target="_blank"><div></div></a>-->
          <!--<a href="http://www.pinguan.com/" target="_blank"><div></div></a>-->
        <!--</div>-->
        <!--<div class="partner partner2">-->
          <!--<a href="https://www.kantarworldpanel.com/global" target="_blank"><div></div></a>-->
          <!--<a href="https://good.tmall.com/" target="_blank"><div></div></a>-->
        <!--</div>-->
        <!--<div class="partner partner3">-->
          <!--<a href="http://www.pentawards.org/" target="_blank"><div></div></a>-->
          <!--<a href="http://www.pentawards.org/" target="_blank"><div></div></a>-->
        <!--</div>-->
        <!--<div style="clear: both"></div>-->
      <!--</div>-->

      <div class="partner-container">
        <div class="flex-1">
          <div>
            <a href="https://www.tmall.com/" target="_blank"><img src="../../src/assets/img/partner/f1.png" alt=""></a>
          </div>
          <div class="margin-top">
              <a href="http://www.pinguan.com/" target="_blank"><img src="../../src/assets/img/partner/f2.png" alt=""></a>
          </div>
          </div>
        <div class="flex-6">
          <div>
             <a href="https://databank.tmall.com/welcome" target="_blank"><img src="../../src/assets/img/partner/f7.png" alt=""></a>
          </div>
        </div>
        <div class="flex-5">
          <div>
             <a href="https://strategy.tmall.com/welcome" target="_blank"><img src="../../src/assets/img/partner/f8.png" alt=""></a>
          </div>
        </div>
        <div class="flex-2">
          <div>
            <a href="https://www.kantarworldpanel.com/global" target="_blank"><img src="../../src/assets/img/partner/f3.png" alt=""></a>
          </div>
          <div class="margin-top">
            <a href="https://good.tmall.com/" target="_blank"><img src="../../src/assets/img/partner/f4.png" alt=""></a>
          </div>
        </div>

        <div class="flex-3">
          <a href="http://www.pentawards.org/" target="_blank"><img src="../../src/assets/img/partner/f5.png" alt=""></a>
        </div>

        <div class="flex-4">
          <a href="http://china.mintel.com/" target="_blank"><img src="../../src/assets/img/partner/f6.png" alt=""></a>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-5 col-lg-5">
      <h3 style="font-weight: 600">{{$t('footer[3].wechataccounts_title')}}</h3>
      <ul class="share" style="margin-top: 0">
        <li>
          <div style="display: inline-block;text-align: center;font-size: 10px">
            <img src="../assets/img/main/1.png" alt="" style="width: 90px"><br>{{$t('footer[3].wechataccounts_content[0]')}}
          </div>
        </li>
        <li>
          <div style="display: inline-block;text-align: center;font-size: 10px">
            <img src="../assets/img/main/2.jpg" alt="" style="width: 90px"><br>{{$t('footer[3].wechataccounts_content[1]')}}
          </div>
        </li>
        <!--<li><a href=""><img src="../assets/img/icon/be-white.png" alt=""></a></li>-->
      </ul>
    </div>
    <div class="col-xs-12 line" style="margin-bottom: 30px;padding-top: 3px" >
      <div class="col-sm-6 col-xs-12 copyright">Copyright ©2017 www.oib-china.com . All Rights Reserved 沪ICP备14026675</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6" lang="babel">

  export default {
    data() {
      return {
        isQRShow: false
      };
    },
    methods: {
      openQR() {
        this.isQRShow = !this.isQRShow;
      }
    }
  };
</script>

<style lang="less" scoped>
.icon {
  background-repeat: no-repeat;
  background-position: left;
  padding-left: 25px;
  line-height: 30px;
  display: inline-block;
  background-size: 18px 18px;
}

.icon-home {
  background-image: url(../assets/img/icon/icon-home_new.png);
}

.icon-case {
  background-image: url(../assets/img/icon/icon-case_new.png);
}

.icon-about {
  background-image: url(../assets/img/icon/icon-about_new.png);
}

.icon-news {
  background-image: url(../assets/img/icon/icon-news.png);
}

.icon-client {
  background-image: url(../assets/img/icon/icon-client_new.png);
}

.icon-contact {
  background-image: url(../assets/img/icon/icon-contact_new.png);
}
  .icon-business{
    background-image: url(../assets/img/icon/icon-business.png);
  }
</style>





// WEBPACK FOOTER //
// src/components/footer.vue